<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }">
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input
            size="small"
            clearable
            placeholder="稿件标题/发布人"
            class="!w-200px"
            v-model="formInline.title"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.status" placeholder="计算状态" clearable>
            <el-option label="待计算" value="0"></el-option>
            <el-option label="不计算" value="1"></el-option>
            <el-option label="已计算" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.royaltiesTypeId" placeholder="稿件类型" clearable>
            <el-option
              v-for="item in royaltiesType"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.royaltiesCategoryId" placeholder="稿件类别" clearable>
            <el-option
              v-for="item in royaltiesCategory"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.royaltiesLevel" placeholder="稿件级别" clearable>
            <el-option
              v-for="item in royaltiesLeavel"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            size="small"
            class="max-w-330px"
            v-model="formInline.timeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="发布时间"
            end-placeholder="发布时间"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          ><el-button size="small" type="primary" @click="searchList">搜索</el-button>
          <el-button size="small" @click="openUploadDialog" :loading="btnLoading"
            >导出</el-button
          ></el-form-item
        >
      </el-form>
    </div>
    <el-table
      height="calc(100% - 106px)"
      :data="tableData"
      v-loading="tableLoading"
      ref="table"
      border
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column type="index" align="center" label="序号" width="50" />
      <el-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :label="item.label"
        :width="item.width"
        :prop="item.prop"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.column.property === 'status'">
            {{ getValue(scope.row[scope.column.property]) }}
          </div>
          <div v-else-if="scope.column.property === 'publishTime'">
            {{ dayjs(scope.row[scope.column.property]).format('YYYY/MM/DD HH:mm:ss') }}
          </div>
          <div v-else-if="scope.column.property === 'isWithImage'">
            {{ scope.row[scope.column.property] ? '是' : '否' }}
          </div>
          <div v-else-if="scope.column.property === 'count'">
            {{ scope.row[scope.column.property].toFixed(2) }}
          </div>
          <div v-else>
            {{ scope.row[scope.column.property] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleView(scope.$index, scope.row)">查看</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="text-right mt-20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import { RoyaltiesRecordApi } from '@wiz-api/workbench'
import { downLoadExcel } from '@/assets/js/CommonDownload'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const royaltiesRecordApi = new RoyaltiesRecordApi()
const dataCategoryApi = new DataCategoryApi()

export default {
  data() {
    return {
      formInline: {
        title: null,
        status: null,
        royaltiesTypeId: null,
        royaltiesCategoryId: null,
        royaltiesLevel: null,
        timeRange: [],
      },
      royaltiesCategory: [],
      royaltiesType: [],
      royaltiesLeavel: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      tableData: [],
      tableLoading: false,
      columnList: [
        {
          label: '稿件标题',
          prop: 'title',
          width: '260',
        },
        {
          label: '栏目名称',
          prop: 'columnName',
          width: '200',
        },
        {
          label: '发布时间',
          prop: 'publishTime',
          width: '170',
        },
        {
          label: '作者',
          prop: 'authors',
          width: '',
        },
        {
          label: '计算状态',
          prop: 'status',
          width: '80',
        },
        {
          label: '稿件类型',
          prop: 'royaltiesTypeName',
          width: '',
        },
        {
          label: '稿件类别',
          prop: 'royaltiesCategoryName',
          width: '',
        },
        {
          label: '稿件级别',
          prop: 'royaltiesLevelName',
          width: '',
        },
        {
          label: '是否配照片',
          prop: 'isWithImage',
          width: '',
        },
        {
          label: '稿费总额',
          prop: 'count',
          width: '80',
        },
      ],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      btnLoading: false,
      selection: [],
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  mounted() {
    this.dataCategoryApi()
    this.searchList()
  },
  methods: {
    selectionChange(selection) {
      this.selection = selection
    },
    async dataCategoryApi() {
      const param = {
        code: 'RoyaltiesCategory',
        includeDetails: true,
      }
      const [err, res] = await dataCategoryApi.getByCode(param)
      if (!err && res) {
        this.royaltiesCategory = res.dataItems
      }

      const params = {
        code: 'RoyaltiesType',
        includeDetails: true,
      }
      const [errType, resType] = await dataCategoryApi.getByCode(params)
      if (!errType && resType) {
        this.royaltiesType = resType.dataItems
      }

      const paramresLeavel = {
        code: 'RoyaltiesLevel',
        includeDetails: true,
      }
      const [errLeavel, resLeavel] = await dataCategoryApi.getByCode(paramresLeavel)
      if (!errLeavel && resLeavel) {
        this.royaltiesLeavel = resLeavel.dataItems
      }
    },
    async searchList() {
      this.tableLoading = true
      const [err, res] = await royaltiesRecordApi.getRoyaltiesRecord(
        this.page.pageNo,
        this.page.pageSize,
        {
          title: this.formInline.title,
          status: this.formInline.status,
          royaltiesCategoryId: this.formInline.royaltiesCategoryId,
          royaltiesTypeId: this.formInline.royaltiesTypeId,
          royaltiesLevel: this.formInline.royaltiesLevel,
          startTime: this.formInline.timeRange ? this.formInline.timeRange[0] ?? null : null,
          endTime: this.formInline.timeRange ? this.formInline.timeRange[1] ?? null : null,
        }
      )
      if (!err && res) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
      this.tableLoading = false
    },
    getValue(val) {
      switch (val) {
        case 0:
          return '待计算'
        case 1:
          return '不计算'
        case 2:
          return '已计算'
        default:
          return ''
      }
    },
    handleView(index, row) {
      this.$router.push({
        path: `${this.routerBase}/portal-management/royalties-management/royalties-compute-management`,
        query: { id: row.id, type: 'view' },
      })
    },
    handleEdit(index, row) {
      this.$router.push({
        path: `${this.routerBase}/portal-management/royalties-management/royalties-compute-management`,
        query: { id: row.id, type: 'edit' },
      })
    },
    async openUploadDialog() {
      this.btnLoading = true
      const [err, res] = await royaltiesRecordApi.royaltiesComputeExport({
        body: {
          pageNo: 1,
          pageSize: 9999,
          title: this.formInline.title,
          status: this.formInline.status,
          royaltiesCategoryId: this.formInline.royaltiesCategoryId,
          royaltiesTypeId: this.formInline.royaltiesTypeId,
          royaltiesLevel: this.formInline.royaltiesLevel,
          startTime: this.formInline.timeRange ? this.formInline.timeRange[0] ?? null : null,
          endTime: this.formInline.timeRange ? this.formInline.timeRange[1] ?? null : null,
          ids: _.map(this.selection, (item) => {
            return item.id
          }),
        },
        returnType: 'Blob',
      })
      if (!err && res) {
        this.btnLoading = false
        downLoadExcel('稿费计算统计导出', res)
      }
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.searchList()
    },
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.searchList()
    },
  },
}
</script>

<style lang="scss" scoped></style>
